<template>
    <dx-popup
        ref="popupRef"
        v-model:visible="state.areaPopupVisible"
        :show-close-button="true"
        title="Добавление области использования"
        :animation="{ value: false }"
        @hidden="onHidden"
        @shown="onShown"
    >
        <local-tree-list ref="areaTreeListRef" :data-source="displayList" :meta="meta">
            <template #toolbarItems>
                <dx-item location="before">
                    <dx-select-box
                        :data-source="displayApps"
                        display-expr="name_app"
                        value-expr="kod_app"
                        :value="app"
                        width="300px"
                        @value-changed="valueChangedSelectBox"
                    />
                </dx-item>
            </template>
        </local-tree-list>
        <dx-toolbar-item location="after" toolbar="bottom">
            <dx-button text="Выбрать" @click="addSelection" />
        </dx-toolbar-item>
        <dx-toolbar-item location="after" toolbar="bottom">
            <dx-button text="Отмена" @click="cancel" />
        </dx-toolbar-item>
    </dx-popup>
</template>

<script setup>
import { DxButton, DxPopup, DxSelectBox } from 'devextreme-vue';
import { DxItem } from 'devextreme-vue/tree-list';
import { DxToolbarItem } from 'devextreme-vue/popup';
import { ref, onMounted, computed } from 'vue';

import LocalTreeList from '@/components/local-tree-list.vue';
import enviromentStore from '@/store/enviroment-data';
import userLocalStore from './store';
import { getCookie } from '@/utils/cookies';

import rolesStore from '@/store/administration/roles';
const { getGroupedAreaList } = rolesStore;

const { state, addMutationAreas } = userLocalStore;

const popupRef = ref();
const areaTreeListRef = ref();
const treeListInstance = ref();
const app = ref(+getCookie('app'));

const displayList = computed(() => {
    const allAreas = getGroupedAreaList('areaListWithApps');

    if (app.value === 'all') return filteringFromEmptyGroups(allAreas);

    const appName = enviromentStore.state.allAppList.find(item => item.kod_app === app.value)?.name_app;
    const areasAndGroupsByApp = allAreas.filter(area => area.isGroup || area.apps?.includes(appName));
    return filteringFromEmptyGroups(areasAndGroupsByApp);
});

const displayApps = computed(() => {
    return [...enviromentStore.state.allAppList, { kod_app: 'all', name_app: 'Все области' }];
});

onMounted(() => {
    treeListInstance.value = areaTreeListRef.value.treeListInstance;
    treeListInstance.value.on('editorPrepared', editorPrepared);
});

const onShown = () => {
    state.isClosingConfirmed = true;
    treeListInstance.value.clearSelection();
    const selectedRowKeys = state.areas.map(area => area.displayId);
    if (selectedRowKeys.length > 0) {
        treeListInstance.value.selectRows(selectedRowKeys, true);
    }
};

const editorPrepared = event => {
    if (event.parentType === 'dataRow' && event.row.data.isGroup) {
        event.cancel = true;
        event.editorElement.style.display = 'none';
    }
};

const onHidden = () => {
    state.roleAreasPopupVisible = true;
};

const cancel = () => {
    state.areaPopupVisible = false;
};

const valueChangedSelectBox = async event => {
    app.value = event.value;
};

const addSelection = () => {
    const selectedRowsData = treeListInstance.value.getSelectedRowsData();
    const selectedAreas = [];

    selectedRowsData.forEach(row => {
        const duplicates = state.areas.filter(area => area.displayId === row.displayId);
        if (duplicates.length === 0) {
            const newRow = row;
            newRow.permission = 'R';
            selectedAreas.push(newRow);
        }
    });

    if (!(selectedAreas.length === 0)) {
        addMutationAreas(selectedAreas);
    }
    state.areaPopupVisible = false;
};

const filteringFromEmptyGroups = data => {
    const idToNode = data.reduce((acc, node) => {
        acc[node.displayId] = node;
        return acc;
    }, {});

    const visited = new Set();

    function visitNode(nodeId) {
        if (visited.has(nodeId)) return;
        visited.add(nodeId);

        const node = idToNode[nodeId];
        if (node && node.parent_id) {
            visitNode(node.parent_id);
        }
    }

    data.forEach(node => {
        if (!node.isGroup) {
            visitNode(node.displayId);
        }
    });

    const resultIds = Array.from(visited);
    return data.filter(item => resultIds.includes(item.displayId));
};

const meta = {
    title: 'Выберите области использования',
    keyExpr: 'displayId',
    parentIdExpr: 'parent_id',
    rootValue: 'NULL',
    scrollingMode: 'standart',
    columns: [
        {
            dataField: 'name',
            caption: 'Область использования',
        },
        {
            dataField: 'description',
            caption: 'Описание',
        },
        {
            dataField: 'apps',
            caption: 'Приложения',
        },
    ],
};
</script>
